import { Meeting } from '../models/chat';
import { ChatMessageInputStore, ChatMessageUpload } from './chat-message-input.store';
import toastr from 'toastr';

export class ChatAttachmentUploadService {
    static $inject = ['$http', 'ChatMessageInputStore'];

    constructor(private $http: ng.IHttpService, private chatMessageInputStore: ChatMessageInputStore) {}

    private id: number = 0;

    private newHash() {
        return ++this.id;
    }

    upload(meeting: Meeting, file: File) {
        const upload$ = this.createUpload$(file);
        const promise = upload$.toPromise() as Promise<ChatMessageUpload>;

        upload$.take(1).subscribe((upload) => this.chatMessageInputStore.dispatchAddUpload(meeting.id, upload));

        upload$.subscribe(
            (upload) => {
                this.chatMessageInputStore.dispatchUpdateUpload(meeting.id, { ...upload, promise });
            },
            () => {
                try {
                    upload$.getValue();
                } catch (e) {
                    toastr.error(e?.error?.data?.file?.[0] || 'File upload error', undefined, {
                        positionClass: 'toast-bottom-right',
                    });
                    this.chatMessageInputStore.dispatchRemoveUpload(meeting.id, e.hash);
                }
            },
            () => {
                this.chatMessageInputStore.dispatchUpdateUpload(meeting.id, { ...upload$.getValue() });
            }
        );
    }

    private createUpload$(file: File): Rx.BehaviorSubject<ChatMessageUpload> {
        const hash = this.newHash();

        const isImage = file.type.startsWith('image/');

        if (file.type.startsWith('image/')) {
            const imageUrl = URL.createObjectURL(file);
        }

        const upload = {
            hash,
            name: file.name,
            progress: '0',
            ...(isImage && { imageUrl: URL.createObjectURL(file) }),
        };
        const subject = new Rx.BehaviorSubject<ChatMessageUpload>(upload);

        const formData = new FormData();

        formData.append('file', file);

        const postParams = {
            method: 'POST',
            url: '/api/v1.0/attachments/pool',
            transformRequest: angular.identity,
            // todo: handle cancel request
            // timeout: new Promise((resolve, reject) => {
            //   this.uploads = this.uploads.map(u => {
            //     if (u.hash === hash) {
            //       return {...u, cancel: resolve};
            //     }
            //     return u;
            //   })
            // }),
            uploadEventHandlers: {
                progress: (e: ProgressEvent) => {
                    if (e.lengthComputable) {
                        const progress = ((e.loaded / e.total) * 100).toFixed(2);
                        subject.onNext({ ...subject.getValue(), progress });
                    }
                },
            },
            data: formData,
            headers: { 'Content-Type': undefined }, // hack?
        };

        const request = this.$http(postParams as any).then(
            (result: any) => {
                subject.onNext({ ...subject.getValue(), remote_id: result.data.data.hash });
                subject.onCompleted();
            },
            (error) => {
                subject.onError({ ...subject.getValue(), error });
            }
        );
        return subject;
    }
}

angular.module('tradersyard').service('ChatAttachmentUploadService', ChatAttachmentUploadService);
